import Base from 'netxcore@netx/core/lib/netx-loading';

import {MDCLinearProgress} from '@material/linear-progress';

function round(value, decimals) {
	return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

/**
 * @class
 * @override
 */
class Loading extends Base {
	/** @override */
	constructor() {
		super();

		this.mdcProgress = new MDCLinearProgress(
			this.el.querySelector('.mdc-linear-progress'),
		);
	}

	// scaleX is jumpy and i do not know why yet
	// /** @override */
	// drawProgress() {
	// 	if (this.progressStalled) return;
	//
	// 	const oldProgress = round(this.progressAmt / 100, 2);
	//
	// 	this.progressAmt += Math.min((100 - this.progressAmt) * 0.02, 100);
	//
	// 	let newProgress = round(this.progressAmt / 100, 2);
	//
	// 	if (newProgress > oldProgress) {
	// 		this.mdcProgress.progress = newProgress;
	// 	}
	//
	// 	if (!this.progressActive) return;
	//
	// 	this.mdcProgress.foundation_.open();
	//
	// 	if (this.progressAmt >= 96 && !this.progressStalled) {
	// 		this.progressStalled = true;
	// 		this.hangingProgressTimeout = setTimeout(() => {
	// 			if (!this.progressStalled) return;
	// 			this.progressIndeterminate();
	// 		}, 2000);
	// 	}
	// }
	//
	// /** @override */
	// progressHide() {
	// 	this.progressEl.classList.add('disable-transition');
	// 	this.progressBarEl.classList.remove('active');
	// 	this.mdcProgress.foundation_.close();
	// 	this.progressAmt = this.mdcProgress.progress = 0;
	// }

	/** @override */
	progressComplete() {
		super.progressComplete();
		// this.progressAmt = 100;
		// this.mdcProgress.progress = 1;
		this.mdcProgress.foundation_.setDeterminate(true);
	}

	/** @override */
	progressIndeterminate() {
		this.mdcProgress.foundation_.setDeterminate(false);
	}
}

export default Loading;
